import { gql } from '@apollo/client'

export const userErrorFragment = gql`
  fragment userError on UserError {
    message
    code
    field
  }
`
